export const ERROR_MODAL_ROUTE_PREFIXES = ['/atrio'] as const;

function normalizeRoute(route: string): string {
  const withoutQueryOrHash = route.trim().split(/[?#]/, 1)[0];
  const withLeadingSlash = withoutQueryOrHash.startsWith('/')
    ? withoutQueryOrHash
    : `/${withoutQueryOrHash}`;

  return withLeadingSlash.replace(/\/+$/, '') || '/';
}

export function isErrorModalEnabledForRoute(route: string): boolean {
  if (!route || !route.trim()) {
    return false;
  }

  const pathname = normalizeRoute(route);

  return ERROR_MODAL_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
